import React, { useCallback } from 'react';

import { useDispatch } from 'react-redux';
import { Upload } from 'components/icons';
import UpsellBanner, { UpsellBannerProps } from 'components/UpsellBanner';
import { onIncreaseUploadLimit } from 'redux/modules/mixpanel';
import { MediaUploadSource } from 'redux/modules/mixpanel/types';
import { EPISODE_MAX_DURATION_UPGRADE_HOURS_VALUE } from 'utils/constants';

export interface AudioDurationUpsellBannerProps
  extends Pick<UpsellBannerProps, 'onUpgradeClick'> {
  className?: string;
  durationLimitHours?: number;
  show: boolean;
  source: MediaUploadSource;
}

const AudioDurationUpsellBanner: React.FC<AudioDurationUpsellBannerProps> = ({
  className,
  onUpgradeClick,
  durationLimitHours = EPISODE_MAX_DURATION_UPGRADE_HOURS_VALUE,
  show,
  source,
}) => {
  const dispatch = useDispatch();
  const handleUpgradeClick = useCallback(
    (e: React.MouseEvent<any>) => {
      onUpgradeClick(e);
      dispatch(onIncreaseUploadLimit(source, 'length'));
    },
    [dispatch, onUpgradeClick, source],
  );

  if (!show) {
    return null;
  }

  return (
    <UpsellBanner
      className={className}
      onUpgradeClick={handleUpgradeClick}
      heading={`Use audio files up to ${durationLimitHours} hours long`}
      actionLabel="Upgrade now"
      icon={<Upload />}
    />
  );
};

export default AudioDurationUpsellBanner;
